import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "skypeContainer" }

import SkypeConvWindow from '@/components/skype/SkypeConvWindow.vue';
import SkypeMsgWindow from '@/components/skype/SkypeMsgWindow.vue';
import { computed, onMounted, onUnmounted } from 'vue';
import { SkypeMutations, SkypeActions } from '@/store/modules/skype';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: 'SkypeContainer',
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const route = useRoute();
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])

onMounted(() => {
    let projId = projectId.value
    let uid = targetId.value
    store.dispatch(`skype/${SkypeActions.asyncGetSkypeUserList}`, { projId, uid });
})

onUnmounted(() => {
    store.commit(`skype/${SkypeMutations.resetAll}`);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SkypeConvWindow),
    _createVNode(SkypeMsgWindow)
  ]))
}
}

})